import $ from 'jquery'
import '@kingshott/iodine'

export default (localeCode) => {
    setLocale(localeCode)

    return {
        submitted: false,
        errorMessage: null,
        inputElements: [],
        init () {
            this.inputElements = [...this.$el.querySelectorAll('[name]')]
            this.initDomData()
            this.updateErrorMessages()
        },
        initDomData: function () {
            this.inputElements.map((el) => {
                let rules = []
                let field = el.name

                if (typeof el.dataset.rules !== 'undefined') {
                    rules = JSON.parse(unicodeToChar(el.dataset.rules))
                }

                if (el.hasAttribute('required') && !rules.includes('required')) {
                    rules.push('required')
                }
                
                if (el.type === 'email') {
                    rules.push('email')
                }

                if (el.id) {
                    let label = this.$el.querySelector(`label[for="${el.id}"]`)

                    if (label && label.textContent) {
                        field = label.textContent.replace(/\s*\*+$/g, '')
                    }

                    if (typeof el.dataset.label !== 'undefined') {
                        field = el.dataset.label
                    }

                    if (field.includes(' ')) {
                        field = `"${field}"`
                    }
                }

                this[el.name] = {
                    field: field,
                    rules: rules,
                    blurred: false,
                    errorMessage: null,
                    serverErrorMessage: null,
                }
            })

            // October CMS AJAX events can only be listened to with jQuery
            $(this.$el).
                on('ajaxSuccess', (event, context, data, status, jqXHR) => {
                    event.preventDefault()
                    this.errorMessage = null
                    this.submitted = true
                }).
                on('ajaxError', (event, context, errorMessage, status, jqXHR) => {
                    event.preventDefault()
                    this.submitted = false
                    this.errorMessage = null

                    if (typeof jqXHR.responseJSON !== 'undefined' && typeof jqXHR.responseJSON.X_OCTOBER_ERROR_FIELDS !== 'undefined') {
                        const errorFields = jqXHR.responseJSON.X_OCTOBER_ERROR_FIELDS

                        Object.keys(errorFields).forEach((name) => {
                            if (typeof this[name] !== 'undefined') {
                                this[name].errorMessage = this[name].serverErrorMessage = errorFields[name].shift().replace(name.replace('_', ' '), this[name].field)
                            } else if (!this.errorMessage) {
                                this.errorMessage = errorFields[name]
                            }
                        })
                    }

                    if (typeof jqXHR.responseJSON === 'undefined') {
                        let locale = getLocale(localeCode)
                        this.errorMessage = locale ? locale.general_error_message : 'Unexpected error'
                        console.error('October CMS error:', errorMessage)
                    }
                })
        },
        updateErrorMessages: function () {
            this.inputElements.map((el) => {
                this[el.name].errorMessage = this.getErrorMessage(el)
            })
        },
        getErrorMessage: function (el) {
            if (this[el.name].serverErrorMessage) {
                return this[el.name].serverErrorMessage
            }

            const error = Iodine.is(el.value, this[el.name].rules)

            if (error !== true && this[el.name].blurred) {
                return Iodine.getErrorMessage(error, {field: this[el.name].field})
            }

            return ''
        },
        submit: function (event) {
            const invalidElements = this.inputElements.filter((input) => {
                return !input.checkValidity() || Iodine.is(input.value, this[input.name].rules) !== true
            })

            if (invalidElements.length > 0) {
                event.preventDefault()
                event.stopPropagation()
                document.getElementById(invalidElements[0].id).scrollIntoView()

                this.inputElements.map((input) => {
                    this[input.name].blurred = true
                })

                this.updateErrorMessages()
            }
        },
        change: function (event) {
            if (!this[event.target.name]) {
                return false
            }

            if (event.type === 'input') {
                this[event.target.name].serverErrorMessage = null
            }

            if (event.type === 'focusout') {
                this[event.target.name].blurred = true
            }

            this.updateErrorMessages()
        },
    }
}

const locales = {
    'en': {
        'general_error_message': 'Unexpected error',
    },
    'nl': {
        'field': 'Waarde',
        'general_error_message': 'Onverwachte fout',
        'error_messages': {
            after         : `De datum moet na '[PARAM]' zijn`,
            afterOrEqual  : `De datum moet na of gelijk aan '[PARAM]' zijn`,
            array         : `[FIELD] moet een array zijn`,
            before        : `De datum moet voor '[PARAM]' zijn`,
            beforeOrEqual : `De datum moet voor of gelijk aan '[PARAM]' zijn`,
            boolean       : `[FIELD] moet true of false zijn`,
            date          : `[FIELD] moet een datum zijn`,
            different     : `[FIELD] moet anders zijn dan '[PARAM]'`,
            endingWith    : `[FIELD] moet eindigen met '[PARAM]'`,
            email         : `[FIELD] moet een geldig e-mailadres zijn`,
            falsy         : `[FIELD] moet een falsy waarde zijn (false, 'false', 0 or '0')`,
            in            : `[FIELD] moet een van de volgende opties zijn: [PARAM]`,
            integer       : `[FIELD] moet een getal zijn`,
            json          : `[FIELD] must be a parsable JSON object string`,
            max           : `[FIELD] moet minder of gelijk aan [PARAM] zijn`,
            min           : `[FIELD] moet meer of gelijk aan [PARAM] zijn`,
            maxLength     : `[FIELD] moet niet langer zijn dan '[PARAM]' karakters`,
            minLength     : `[FIELD] moet niet minder dan '[PARAM]' karakters zijn`,
            notIn         : `[FIELD] moet niet een van de volgende opties zijn: [PARAM]`,
            numeric       : `[FIELD] moet numeriek zijn`,
            optional      : `[FIELD] is optioneel`,
            regexMatch    : `[FIELD] moet voldoen aan de volgende regex: [PARAM]`,
            required      : `[FIELD] moet ingevuld zijn`,
            same          : `[FIELD] moet hetzelfde als '[PARAM]' zijn`,
            startingWith  : `[FIELD] moet beginnen met '[PARAM]'`,
            string        : `[FIELD] moet een string zijn`,
            truthy        : `[FIELD] moet een truthy waarde zijn (true, 'true', 1 or '1')`,
            url           : `[FIELD] moet een geldige url zijn`,
            uuid          : `[FIELD] moet een geldige UUID zijn`,
        }
    }
}

function getLocale(localeCode) {
    return typeof locales[localeCode] === 'undefined' ? null : locales[localeCode]
}

function setLocale(localeCode) {
    let locale = getLocale(localeCode)

    if (!locale) {
        return
    }

    if (typeof locale.field !== 'undefined') {
        Iodine.setDefaultFieldName(locale.field)
    }

    if (typeof locale.error_messages !== 'undefined') {
        Iodine.setErrorMessages(locale.error_messages)
    }
}

function unicodeToChar(text) {
    return text.replace(/\\u[\dA-F]{4}/gi,
        function (match) {
            return String.fromCharCode(parseInt(match.replace(/\\u/g, ''), 16));
        });
}
